const ErrorIcon = () => {
  return (
      <svg
        width="72"
        height="72"
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1475_4170)">
          <path
            d="M36 0C16.1488 0 0 16.1488 0 36C0 55.8512 16.1488 72 36 72C55.8512 72 72 55.8512 72 36C72 16.1488 55.8512 0 36 0Z"
            fill="#F12A00"
          />
          <path
            d="M49.2573 45.0149C50.4301 46.1882 50.4301 48.0839 49.2573 49.2573C48.6723 49.8423 47.9043 50.1362 47.1358 50.1362C46.3679 50.1362 45.5999 49.8423 45.0149 49.2573L36.0001 40.2419L26.9852 49.2573C26.4002 49.8423 25.6323 50.1362 24.8643 50.1362C24.0958 50.1362 23.3279 49.8423 22.7429 49.2573C21.5701 48.0839 21.5701 46.1882 22.7429 45.0149L31.7583 36.0001L22.7429 26.9852C21.5701 25.8119 21.5701 23.9162 22.7429 22.7429C23.9162 21.5701 25.8119 21.5701 26.9852 22.7429L36.0001 31.7583L45.0149 22.7429C46.1882 21.5701 48.0839 21.5701 49.2573 22.7429C50.4301 23.9162 50.4301 25.8119 49.2573 26.9852L40.2419 36.0001L49.2573 45.0149Z"
            fill="#FAFAFA"
          />
        </g>
        <defs>
          <clipPath id="clip0_1475_4170">
            <rect width="72" height="72" fill="white" />
          </clipPath>
        </defs>
      </svg>
  );
};
export default ErrorIcon;
